import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustompageRequest, CustompageRequestAdd, CustompageRequestSearch } from '../../../models/api-store/custompage/custompage.request.model';
import { CustompageResponse, CustompageResponseSearch } from '../../../models/api-store/custompage/custompage.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustompageService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.custompage;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  findAll(pageNumber,pageSize):Observable<CustompageResponseSearch>{
    let url = this.url +"/" +"?pageNumber="+pageNumber+"&pageSize="+pageSize;
    return this.http.get<CustompageResponseSearch>(url);
  }

  create(request: CustompageRequest): Observable<CustompageResponse> {
    let url = this.url;
    return this.http.post<CustompageResponse>(url, request);
  }

  getEntity(id: number): Observable<CustompageResponse> {
    let url = this.url + "/" + id;
    return this.http.get<CustompageResponse>(url);
  }

  update(id: number, request: CustompageRequest): Observable<CustompageResponse> {
    let url = this.url + "/" + id;
    return this.http.put<CustompageResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }

  publish(id:number,published:boolean):Observable<CustompageResponse>{
    let url = this.url +"/" + id + "/publish?published="+published;
    let request = {}
    request['id'] = id;
    request['published'] = published;
    return this.http.put<CustompageResponse>(url,request);
  }

  removeFooter(id:number,removeFooter :boolean):Observable<CustompageResponse>{
    let url = this.url +"/" + id + "/removeFooter?removeFooter="+removeFooter ;
    let request = {}
    request['id'] = id;
    request['removeFooter '] = removeFooter ;
    return this.http.put<CustompageResponse>(url,request);
  }

  addActivityMap(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addActivityMap";
    return this.http.put<any>(url, request);
  }

  addDealerMap(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addDealerMap";
    return this.http.put<any>(url, request);
  }

  addNewsFilter(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addNewsFilter";
    return this.http.put<any>(url, request);
  }

  addProductService(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addProductService";
    return this.http.put<any>(url, request);
  }

  addPromotionevent(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addPromotionevent";
    return this.http.put<any>(url, request);
  }

  addShoppingMall(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addShoppingMall";
    return this.http.put<any>(url, request);
  }

  addStore(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/addStore";
    return this.http.put<any>(url, request);
  }

  removeActivityMap(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeActivityMap";
    return this.http.put<any>(url, request);
  }

  removeDealerMap(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeDealerMap";
    return this.http.put<any>(url, request);
  }

  removeNewsFilter(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeNewsFilter";
    return this.http.put<any>(url, request);
  }

  removeProductService(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeProductService";
    return this.http.put<any>(url, request);
  }

  removePromotionEvent(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removePromotionEvent";
    return this.http.put<any>(url, request);
  }

  removeShoppingMall(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeShoppingMall";
    return this.http.put<any>(url, request);
  }

  removeStore(id,request:CustompageRequestAdd):Observable<any>{
    let url = this.url + "/" + id + "/removeStore";
    return this.http.put<any>(url, request);
  }

  search(request:CustompageRequestSearch):Observable<CustompageResponseSearch>{
    let url = this.url +"/" +"search";
    return this.http.post<CustompageResponseSearch>(url,request);
  }

  findAllActivitesList():Observable<any>{
    let url = this.url + "/activity-map";
    return this.http.get<any[]>(url);
  }

  findAllDealer():Observable<any>{
    let url = this.url + "/dealer-map";
    return this.http.get<any[]>(url);
  }

}
